import { FAQPage } from '@/components/equip/FAQPage';
import { nonPhysicianFAQ, nonPhysicianFAQCategories } from '@/data/non-physician-faq';
import type { EmploymentStatus } from '@/data/types';

interface NonPhysicianFAQProps {
  employmentStatus?: EmploymentStatus;
}

export function NonPhysicianFAQ(_props: NonPhysicianFAQProps = {}): JSX.Element {
  return (
    <FAQPage
      rolePrefix="non-physician"
      items={nonPhysicianFAQ}
      categories={nonPhysicianFAQCategories}
    />
  );
}
